module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/en/4/2-caeda1907cf7c3a8a40845b19cdf98af.jpg";